import type { Routemize_DTOs_CompanyLocationDto } from '@/api/models/Routemize_DTOs_CompanyLocationDto';

/** Reject null island and other unusable stored coordinates. */
export function isValidMapCoordinates(
  latitude?: number | null,
  longitude?: number | null,
): boolean {
  if (latitude == null || longitude == null) return false;
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return false;
  if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return false;
  // Backend sometimes persists (0, 0) when geocoding was skipped.
  if (Math.abs(latitude) < 1e-6 && Math.abs(longitude) < 1e-6) return false;
  return true;
}

export function formatCompanyLocationAddress(
  location: Routemize_DTOs_CompanyLocationDto,
): string {
  if (location.fullAddress?.trim()) return location.fullAddress.trim();
  return [
    location.addressLine1,
    location.addressLine2,
    location.city,
    location.state,
    location.zipCode,
    location.country,
  ]
    .filter(Boolean)
    .join(', ')
    .trim();
}

export function getCompanyLocationCoordinates(
  location: Routemize_DTOs_CompanyLocationDto | null | undefined,
): { lat: number; lng: number } | null {
  if (!location) return null;
  if (isValidMapCoordinates(location.latitude, location.longitude)) {
    return { lat: location.latitude!, lng: location.longitude! };
  }
  return null;
}
